import { useState } from "react";
import css from "./Gallery.module.css";

const Image = ({ img, isHalf }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={css.container}>
      <img
        className={css.img}
        src={img.src}
        alt={img.alt}
        style={{ opacity: loaded ? 1 : 0 }}
        onLoad={() => setLoaded(true)}
      />
      {/* {img.title && (
        <div className="flex between">
          <strong>{img.title}</strong>
          <i>{img.date}</i>
        </div>
      )} */}
    </div>
  );
};

export default Image;
